import * as React from "react";
import {
  WidgetFrame,
  WidgetGrid,
  WidgetGridModel,
} from "../../../personal-studio-components/studio";
import CalendarLessonDetail from "../calendarLessonDetail/CalendarLessonDetail";
import CalendarGraphicWidget from "./CalendarGraphicWidget";
function CalendarGraphic() {
  const model = new WidgetGridModel({
    widget: {
      CalendarGraphic: <CalendarGraphicWidget />,
      CalendarLessonDetail: (
        <WidgetFrame type="yellow" icon="calendar" title="Календарь">
          <CalendarLessonDetail />
        </WidgetFrame>
      ),
    },
    grid: [
      {
        id: "CalendarGraphic",
        colspan: 2,
        visible: true,
      },
      {
        id: "CalendarLessonDetail",
        colspan: 1,
        visible: true,
      },
    ],
  });
  return <WidgetGrid {...model} />;
}
export default CalendarGraphic;
